import { render, staticRenderFns } from "./EditDetailsTab.vue?vue&type=template&id=cfea911e"
import script from "./EditDetailsTab.vue?vue&type=script&lang=js"
export * from "./EditDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./EditDetailsTab.vue?vue&type=style&index=0&id=cfea911e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports